module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/female_breast-7f432a6c63d94460e6023ae560150670.png";